import { GlobalToken } from 'antd';

import { StationPressureType } from '@/constants/stationPressureType.enum';
import StationStore from '@/store/Station/StationStore';

const getDefaultPowerScaleColors = token => [
  token.colorSuccess,
  token.colorSuccess,
  token.colorWarning,
  token.colorWarning,
  token.colorError,
];

const getDefaultPowerScaleFadedColors = token => [
  token.colorSuccessBorder,
  token.colorSuccessBorder,
  token.colorWarningBorder,
  token.colorWarningBorder,
  token.colorErrorBorder,
];

const highPressurePowerRangeStationIds: string[] = [
  'd2914669-ae71-4882-9135-84d300d0081e',
  'aea1cb9e-3bf8-4295-bcb9-524be080d322',
  'c06b8601-47f5-4c29-b489-4837356dd496',
  '492480be-c108-4372-a948-9875447e5c35',
  'fc50fe86-51ce-41f1-9d66-eb12a0cd5dbc',
  'a533549e-742c-4b3f-9b41-7344ea9b8143',
  '275879c4-c84f-47d2-a49b-85bdd26f82bc',
];
const DEFAULT_HIGH_PRESSURE_METRIC_POWER_RANGE: number[] = [9.53, 11.3, 13.06, 14.83, 16.6];
const DEFAULT_LOW_PRESSURE_METRIC_POWER_RANGE: number[] = [5.3, 6.01, 6.71, 7.41, 8.11, 13];
const DEFAULT_WASTE_WATER_PRESSURE_METRIC_POWER_RANGE: number[] = [0, 2000, 4000, 6000, 8000];

function getPredefinedSpecificPowerRange(stationStore: StationStore): number[] {
  if (
    stationStore.currentStation.stationPressureType === StationPressureType.HighPressure ||
    highPressurePowerRangeStationIds.includes(stationStore.currentStation.id)
  ) {
    return DEFAULT_HIGH_PRESSURE_METRIC_POWER_RANGE;
  } else if (stationStore.isWasteWaterStation) {
    return DEFAULT_WASTE_WATER_PRESSURE_METRIC_POWER_RANGE;
  }

  return DEFAULT_LOW_PRESSURE_METRIC_POWER_RANGE;
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type TvalueFunction<T = any, R = any> = (
  value: T,
  unit?: string,
  toMeasurementSystem?: string,
  fromMeasurementSystem?: string,
) => R;

export function getPredefinedPowerScale(
  stationStore: StationStore,
  tvalue: TvalueFunction,
  token: GlobalToken,
): { colors: string[]; values: number[]; fadedColors: string[] } {
  const powerRangeValues: number[] = getPredefinedSpecificPowerRange(stationStore);
  // Ensure that the length of DEFAULT_POWER_SCALE_COLORS matches the length of powerRangeValues
  const adjustedColors = getDefaultPowerScaleColors(token).slice(0, powerRangeValues.length);
  const adjustedFadedColors = getDefaultPowerScaleFadedColors(token).slice(0, powerRangeValues.length);
  return {
    colors: adjustedColors,
    fadedColors: adjustedFadedColors,
    values: getPredefinedSpecificPowerRange(stationStore).map(value => tvalue(value, 'kW/(m^3/min)')),
  };
}
